import './terms.css'
function Terms() {
    return <div className="terms-space">
        <text className='header-text'>
            Terms & Conditions
        </text>
        <section>
            <b className="terms-upcase">
                SHIPPER
            </b>
            <p>
                Orders are processed within a maximum of 2 business days from the order date.
                Estimated delivery times:
                All orders are shipped with a tracking number and will take no more than 20 business days to reach
                the buyer;
                please note that the number varies depending on your region.
                I am not responsible for delivery times and cannot guarantee them.
                Customs and import duties are the responsibility of the buyers. I am not responsible for prolonged
                delays by customs.
            </p>
            <b className="terms-upcase">
                SECURE PAYMENT
            </b>
            <p>
                Accepted payment methods: PayPal, Visa, MasterCard, American Express...
                This store securely processes your payment data and never has access to your credit card
                information.
            </p>
            <b className="terms-upcase">
                RETURNS
            </b>
            <p>
                Returns are accepted within 14 days of receiving the order.
                Return shipping costs are the responsibility of the buyer.
                Refund will be issued upon receipt of the returned items.
                If returned items are not in their original condition, any loss in value is
                the responsibility of the buyer.
                I do not accept exchanges or cancellations. But feel free to contact me if there is any issue with your
                order.
            </p>
            <b className="terms-upcase">
                DAMAGED ITEMS
            </b>
            <p>
                Each order is carefully packaged, but unfortunately, damage may occur during transit. If this is the
                case, please send photos of the damage
                to emilioramosdelafuente@gmail.com, and I will do my best to replace
                your item immediately.
            </p>
            <b className="terms-upcase">
                NOTE
            </b>
            <p>
                payment receipt issued by the artist
            </p>
        </section>
    </div>

}
export default Terms